import { RouteProps } from "react-router-dom";

import { authPagesMenu } from "../menu";
import DefaultAside from "../pages/_layout/_asides/DefaultAside";

const asides: RouteProps[] = [
  { path: authPagesMenu.login.path, element: null },
  { path: authPagesMenu.signUp.path, element: null },
  { path: authPagesMenu.verifyOtp.path, element: null },
  { path: "/apartment-admin", element: null },
  // { path: pageLayoutTypesPagesMenu.blank.path, element: null },
  { path: "*", element: <DefaultAside /> },
];

export default asides;
